import { Schema as S } from "effect";

/** Shared scheduling contract for TimeSlot.
 * @since 1.1.8
 * @example TimeSlot;
 */
export const TimeSlot = S.Struct({
  id: S.String,
  calendarId: S.String,
  appointmentTypeId: S.String,
  startTime: S.String,
  endTime: S.String,
  available: S.Boolean,
});

/** Shared scheduling contract for TimeSlot.
 * @since 1.1.8
 * @example TimeSlot;
 */
export type TimeSlot = S.Schema.Type<typeof TimeSlot>;

/** Shared scheduling contract for TimeSlotList.
 * @since 1.1.8
 * @example TimeSlotList;
 */
export const TimeSlotList = S.Array(TimeSlot);
/** Shared scheduling contract for TimeSlotList.
 * @since 1.1.8
 * @example TimeSlotList;
 */
export type TimeSlotList = S.Schema.Type<typeof TimeSlotList>;
